// src/pages/Produtos/profiles/base/defaults.js
export const baseDefaults = {
    natureza: null, // se quiser usar depois
    labelForm: 'Gestão de Produtos',
    // abas “possíveis” no sistema Produto (todas)
    tabs: {
        cabecalho: { enabled: true }, // infos genéricas
        industria: { enabled: false },
        materiaPrima: { enabled: false },
        modoProducao: { enabled: false },
        embalagens: { enabled: true }, // você disse: obrigatória (mas pode cadastrar depois)
        caracteristicas: { enabled: true },
        bens: { enabled: false }, // bens / imóvel / veículo compartilham base
        mobilia: { enabled: false }, // só imóvel
        imagens: { enabled: true },
    },

    // “UI contracts” por aba (labels/show/readonly/disabled etc.)
    uiTabs: {
        cabecalho: {
            labels: {
                grid: 'Informações principais do Produto',
                labFabricante: 'Fabricante',
                labNcm: 'NCM',
                labEmpresa: 'Empresa',
            },
            show: {
                //1ª div cabeçalho
                empresa: true,
                compra: true,
                venda: true,
                locavel: true,
                industria: true,
                servico: true,

                ncm: true,
                fabricante: true,

                flagsProduto: true, // industria/materiaPrima/bobina etc
            },
            readonly: {},
            disabled: {},
        },

        industria: {
            show: {
                bobinaId: true,
                cilindroId: true,
                pesoMolecular: true,
                tolerancia: true,
                producaoMinima: true,
            },
        },

        materiaPrima: { show: {} },

        modoProducao: {
            labels: {
                grid: 'Instruções de produção do produto',
            },
            show: {},
        },

        embalagem: {
            titles: { grid: 'embalagens aplicadas ao produto', codigoBarras: 'digite o código de barras da embalagem' },
            labels: { grid: 'Informações das embalagens', codigoBarras: 'Código de Barras' },
            show: {
                codigoBarras: true,
                principal: true,
                aceitaFracao: true,
            },
            parametros: {
                // regra útil: sem embalagem => não vende/não tabela preço
                exigeEmbalagemParaVenda: true,
            },
        },

        caracteristicas: { show: {} },

        bens: {
            titles: { grid: 'Patrimônio' },
            labels: {
                grid: 'Patrimônio/Ativos',
                form: 'Informações de Patrimônio e Ativos',
            },
            show: {
                // você liga/desliga por categoria (vtr/imovel/bem)
                veiculo: false,
                imovel: false,
                bemMovel: false,
                mobiliado: false,
            },
        },

        mobilia: { show: {} },

        imagens: {
            show: {
                upload: true,
                galeria: true,
            },
        },
    },

    // comportamento/flags internas da tela
    function: {
        // exemplo:
        autoCalcularVolume: true, // se altura/largura/comprimento muda
    },

    // defaults/parametros do módulo produto
    parametros: {
        // defaults para campos do produto
        defaultsProduto: {
            ativo: true,
            compra: true,
            venda: true,
            locavel: false,
            servico: false,
            industria: false,
            materiaPrima: false,
            isBobina: false,
            bem: false,
            imovel: false,
            vtr: false,
            pesavel: false,
            naoAplicaDesconto: false,
        },

        // “contratos” de saneamento/limpeza
        sanitize: {
            // chaves sempre mantidas do Produto “pai”
            keepBase: [
                'id',
                'uuid',
                'ativo',
                'empresaId',
                'descricao',
                'tipo',
                'codigo',
                'codigoFabricante',
                'referencia',
                'fabricanteId',
                'ncmId',
                'compra',
                'venda',
                'locavel',
                'servico',
                'industria',
                'materiaPrima',
                'isBobina',
                'bem',
                'imovel',
                'vtr',
                'almoxarifadoId',
                'altura',
                'largura',
                'comprimento',
                'volume',
                'pesoBruto',
                'pesoLiquido',
                'estoqueMinimo',
                'comissao',
                'pesavel',
                'naoAplicaDesconto',

                // bobina flags
                'bobinaSanfonada',
                'bobinaTransparente',
                'bobinaTratada',
                'bobinaComprimento',
                'bobinaDiametro',
                'produtoBobinaId',

                // industria
                'bobinaId',
                'cilindroId',
                'pesoMolecular',
                'toleranciaMinima',
                'toleranciaMaxima',
                'producaoMinima',

                // datas/valores (se você usa nos bens)
                'valor',
                'dataCompra',
                'valorVenda',
                'dataVenda',
                'valorPercentualMin',
                'valorPercentualMax',
            ],

            // filhos “possíveis” (a categoria habilita/inhabilita)
            childrenMap: {
                empresa: 'Empresa',
                ncm: 'NCM',
                fabricante: 'Fabricante',
                bens: 'produtoBens',
                embalagens: 'produtoEmbalagens',
                imagens: 'produtoImagens', // <- se teu back manda "produtoImagem", ajusta no index.js
                composicoes: 'produtoComposicoes',
                cores: 'produtoCores',
                tabelaPrecoItens: 'tabelaPrecoItems',
            },
        },
    },
};
